import React, { Component } from 'react'

import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import MenuItem from '@mui/material/MenuItem'
import { ConfirmDialog } from '../dialogs/ConfirmDialog'
import { ProfileActions } from './ProfileActions'
import Months from './Months'

import '../../styles/Profile.css'

export default class Education extends Component {
    state = {
        openConfirmDialog: false,
    };
    
    handleOpenConfirmDialog = () => {
        this.setState({ openConfirmDialog: true });
    };
    
    handleCloseConfirmDialog = () => {
        this.setState({ openConfirmDialog: false });
    };

    handleEdit = () => {
        this.props.handleEdit(this.props.index)
    }

    handleDelete = () => {
        this.props.handleDelete(this.props.index)
        this.handleCloseConfirmDialog()
    }

    handleChange = event => {
        const newEducation = Object.assign({}, this.props.education, {
            [event.target.name]: event.target.value
        })

        this.props.handleChange(this.props.index, newEducation)
    };

    handleSaveSection = e => {
        e.preventDefault();

        this.props.handleSaveSection(this.props.index)
    };

    handleCancel = () => {
        this.props.handleCancel()
    }

    getMonthLabel = (month) => {
        if (month){
            return Months[month - 1].label
        }
        return ''
    }

    getDatesString = (data) => {
        let text = '';

        text = this.getMonthLabel(data.startMonth) + ' ' + data.startYear + ' - '

        if (data.endMonth && data.endYear) {
            text = text + this.getMonthLabel(data.endMonth) + ' ' + data.endYear
        } else {
            text = text + 'present'
        }

        return text;
    }

    render() {
        const {editMode, education, noEdit} = this.props
        //const searchWords = this.props.searchWords ||  []
        return (
            <div className="profileListSection">
                {(editMode)?
                <form onSubmit={this.handleSaveSection}>
                    <Grid container spacing={3}>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                variant="standard"
                                id="school"
                                name="school"
                                label="School"
                                margin="none"
                                fullWidth
                                required
                                value={education.school || ''}
                                onChange={this.handleChange} />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                variant="standard"
                                id="degree"
                                name="degree"
                                label="Degree/Certificate"
                                margin="none"
                                fullWidth
                                value={education.degree || ''}
                                onChange={this.handleChange} />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                variant="standard"
                                id="fieldOfStudy"
                                name="fieldOfStudy"
                                label="Field of study"
                                margin="none"
                                fullWidth
                                value={education.fieldOfStudy || ''}
                                onChange={this.handleChange} />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                variant="standard"
                                id="location"
                                name="location"
                                label="Location"
                                margin="none"
                                fullWidth
                                value={education.location || ''}
                                onChange={this.handleChange} />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                variant="standard"
                                id="startMonth"
                                name="startMonth"
                                label="Start Month"
                                margin="none"
                                fullWidth
                                required
                                select
                                value={education.startMonth || ''}
                                onChange={this.handleChange}>
                                {Months.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                variant="standard"
                                id="startYear"
                                name="startYear"
                                label="Start Year"
                                margin="none"
                                fullWidth
                                required
                                type="number"
                                value={education.startYear || ''}
                                onChange={this.handleChange} />
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                variant="standard"
                                id="endMonth"
                                name="endMonth"
                                label="End Month"
                                margin="none"
                                fullWidth
                                select
                                type="number"
                                value={education.endMonth || ''}
                                onChange={this.handleChange}>
                                {Months.map(option => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <TextField
                                variant="standard"
                                id="endYear"
                                name="endYear"
                                label="End Year"
                                margin="none"
                                fullWidth
                                type="number"
                                value={education.endYear || ''}
                                onChange={this.handleChange} />
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <TextField
                                variant="standard"
                                id="description"
                                name="description"
                                label="Description"
                                margin="none"
                                fullWidth
                                multiline
                                maxRows="4"
                                value={education.description || ''}
                                onChange={this.handleChange} />
                        </Grid>
                    </Grid>
                    <div className="profileButtons">
                        <Button
                            color="primary"
                            size="small"
                            onClick={this.handleCancel}
                            aria-label="Cancel"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="outlined"
                            color="primary"
                            size="small"
                            aria-label="Save Changes"
                        >
                            Save Changes
                        </Button>
                    </div>
                </form> :
                <React.Fragment>
                    {(!noEdit)&&<React.Fragment>
                    <ConfirmDialog 
                        title="Delete Education" 
                        contentText="Are you sure you want to delete this education?" 
                        open={this.state.openConfirmDialog} 
                        handleClose={this.handleCloseConfirmDialog}
                        handleAgree={this.handleDelete}/>
                    <ProfileActions handleEdit={this.handleEdit} handleDelete={this.handleOpenConfirmDialog}/></React.Fragment>}
                    <div className="profileField list">
                        <div className="title">
                            {education.school || ''}
                            {/*<Highlighter
                                highlightClassName="YourHighlightClass"
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={education.school || ''}
                            />*/}
                        </div>
                        {(education.degree || !noEdit)&&<div className="underTitle">
                            {(education.degree)?
                                <React.Fragment>
                                    {education.degree + ((education.fieldOfStudy)?', '+ education.fieldOfStudy:'')}
                                    {/*<Highlighter
                                        highlightClassName="YourHighlightClass"
                                        searchWords={searchWords}
                                        autoEscape={true}
                                        textToHighlight={education.degree + ((education.fieldOfStudy)?', '+ education.fieldOfStudy:'')}
                                    />*/}
                                </React.Fragment>:
                                <React.Fragment><span onClick={this.handleEdit} className="profileEditText">+ Degree</span></React.Fragment>}
                        </div>}
                        {(education.location || !noEdit)&&<div className="location">
                            {(education.location)?
                                <React.Fragment>{education.location}</React.Fragment>:
                                <React.Fragment><span onClick={this.handleEdit} className="profileEditText">+ Location</span></React.Fragment>}
                        </div>}
                        {(education.description || !noEdit)&&<div className="description">
                            {(education.description)?
                                <React.Fragment>
                                    {education.description || ''}
                                    {/*<Highlighter
                                        highlightClassName="YourHighlightClass"
                                        searchWords={searchWords}
                                        autoEscape={true}
                                        textToHighlight={education.description || ''}
                                    />*/}
                                </React.Fragment>:
                                <React.Fragment><span onClick={this.handleEdit} className="profileEditText">+ Description</span></React.Fragment>}
                        </div>}
                        <div className="dates">{this.getDatesString(education)}</div>
                    </div>      
                </React.Fragment>}
            </div>
        );
    }
}